/* Ernte-FRUCHT */

angular.module('cfn').directive('cfnBookingSysculture', [
  '$rootScope',
  '$http',
  'bookingService',
  'bookingRules',
  'companyFinanceService',
  'userSettingsService',
  'search.service',
  'cultureSearch.service',
  'sysCultureServiceTable.service',
  function (
    $rootScope,
    $http,
    bookingService,
    bookingRules,
    companyFinanceService,
    userSettingsService,
    searchService,
    cultureSearchService,
    sysCultureServiceTableService
  ) {
    return {
      restrict: 'E',
      templateUrl: require('./sysCultureTable.html'),
      controller: [
        '$scope',
        '$log',
        function ($scope, $log) {
          $scope.isEngland = userSettingsService.getIsoCountryEnum() === 'GBR';
          /**
           * watches selection of culture in fruit tab
           */       
          $scope.$on('bookingmask-culture-changed', (event, args) => {
            if (!$scope.cropOfHarvest) $scope.cropOfHarvest = {};

            if (typeof args !== 'undefined' && args && args.cropOfOperation && args.cropOfOperation.sysCultureDTO && args.cropOfOperation.sysCultureDTO.id) {
              $scope.currentSysCultureId = args.cropOfOperation.sysCultureDTO.id;
              $scope.cropOfHarvest = angular.copy(args.cropOfOperation);
              let harvestUnitWasUndefined = false; 
              if($scope.details.product){
                if(!$scope.details.product.unit) {
                    harvestUnitWasUndefined = true;
                    $scope.details.product.unit = $scope.cropOfHarvest.harvestUnit;
                }
                $scope.details.product.sowingType = sowingTypeForHarvest($scope.cropOfHarvest.sowingType);
              }

              if(args.cropOfOperation.source && args.cropOfOperation.source == 'init' && $scope.details.product){
                $scope.details.product.harvestType = $scope.cropOfHarvest.harvestType;
                return;
              }

              if($scope.details.product){
                $scope.details.product.harvestType = undefined;
                if(!$scope.details.product.unit) {
                    harvestUnitWasUndefined = true;
                    $scope.details.product.unit = $scope.cropOfHarvest.harvestUnit;
                }
                $scope.details.product.sowingType = sowingTypeForHarvest($scope.cropOfHarvest.sowingType);
              }
              if(harvestUnitWasUndefined && $scope.details.activities && $scope.details.activities.indexOf('HARVESTING') != -1) {
                sysCultureServiceTableService.showInfoMessageWhenHarvestUnitsNotUnique($scope.currentSysCultureId);
              }
            } else {
                $scope.cropOfHarvest = null;
            }
          });
          
          let sowingTypeForHarvest = (sowingTypOfCurrentCrop) => {
              let sowingType = 'MAIN_CROP'
              if(sowingTypOfCurrentCrop == 'PERMANENT_CROP') {
                sowingType = 'PERMANENT_CROP';
              }
              return sowingType;
          }

          
          // Transform details-data (fieldList, seedList, ...) to BE-Data (assets, products,...)

          bookingRules.elements.sysCulture.onSave = function (result) {
            if ($scope.details.product) {
              result.products = [angular.copy($scope.details.product)];
            }
            result.productProportions = angular.copy(
              $scope.details.productProportions
            );
          };

          bookingRules.elements.sysCulture.onInsert = function (sysCultureDTO) {
            var newItem = sysCultureDTO;
            newItem.feid = sysCultureDTO.product.id;
            bookingService.addToList($scope, newItem, 'product');
          };

          // Limits selectable harvest units to the reasonable ones
          $scope.sysCultureUnits = [
            'MASS_KG',
            'MASS_DT',
            'MASS_T',
            'QUANTITY_PIECE',
            'QUANTITY_UNIT'
          ];

          $scope.harvestType_options = enums.HarvestTypeEnum.options;

          // Init
          $scope.details.productProportions = [];
          $scope.bookingRules = bookingRules;

          // New Item?
          $scope.$watchCollection('details.productProportions', function (
            newValue,
            oldValue
          ) {
            if (newValue !== oldValue && newValue) {
              bookingService.summation($scope, 'productProportions');
            }
          });
          
          // Synchronisiere gewählte Schläge mit der Aufteilungs-Ansicht
          $scope.$watchCollection('details.fieldList', function (
            newVal,
            oldVal
          ) {
            if (oldVal !== newVal) {
              if (!$scope.details.productProportions)
                $scope.details.productProportions = [];
              bookingService.mergeFieldList(
                $scope,
                'productProportions',
                function (newItem) {
                  newItem.productType = 'SysCulture';
                }
              );
            }
          });

          // input-Field changed?
          $scope.changeAnteilField = function (fieldName, item) {
            bookingService.calculation(
              $scope,
              fieldName,
              item,
              $scope.details.product[0]
            );
            bookingService.summation($scope, 'productProportions');
          };

          $scope.changeTotalAmount = function() {
            $scope.details.productProportions.forEach(function (anteilItem) {
              anteilItem.amount = (anteilItem.area / $scope.details.productProportions_area_sum) * $scope.details.productProportions_amount_sum;
              bookingService.calculation(
                  $scope,
                  'amount',
                  anteilItem,
                  $scope.details.product[0]
              );
            });
            bookingService.summation($scope, 'productProportions');
          };

          // input-Field changed? -> recalc all Anteil-Fields
          $scope.changeField = function (fieldName, item) {
            $scope.details.productProportions.forEach(function (anteilItem) {
              bookingService.calculation($scope, fieldName, anteilItem, item);
            });
            bookingService.summation($scope, 'productProportions');
          };


          // SEARCH
          let objectType = $scope.ele.name,
            type = 'supply',
            list = objectType + 'List';

          let searchIndex = searchService(objectType, {
            initOnFirstSearch: true
          }).buildIndex({
            fullText: function (item) {
              return [
                item.number,
                item.name,
                item.sysSeed_sysCulture_abbrFruit,
                enums.SortCategoryEnum[item.sysSeed_sysCulture_category],
                item.sysSeed_sysCulture_name
              ];
            },
            handleResults: function (data) {
              data.map(function (elem) {
                elem._objectType = objectType;
                $log.debug('called handleResults: ', elem._objectType);
              });
              return data;
            }
          });

          /**
           * change handler for selecting a harvest type
           */
          $scope.harvestTypeChanged = function () {
            if (!$scope.details.product.harvestType) {
              return;
            }
            // set harvestProduct and harvestType the same
            if ($scope.cropOfHarvest.harvestTypes) {
              for (let i = 0; i < $scope.cropOfHarvest.harvestTypes.length; i++) {
                if ($scope.cropOfHarvest.harvestTypes[i].type === $scope.details.product.harvestType) {
                  $scope.details.product.harvestProduct = $scope.cropOfHarvest.harvestTypes[i];
                  return;
                }
              }
            }
          }
          $scope.getHarvestUnits = function() {
              return ['MASS_KG',
              'MASS_DT',
              'MASS_T',
              'QUANTITY_PIECE']             
          }
        }
      ],
      controllerAs: 'ctrl'
    };
  }
]);
